import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type LoginPolicyCreateConfirmationModalProps = {
  onConfirm: () => void;
};

const LoginPolicyCreateConfirmationModal = create(function LoginPolicyCreateConfirmationModal({
  onConfirm,
}: LoginPolicyCreateConfirmationModalProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Create policy"
      confirmationButtonLabel="Save"
      confirmationButtonVariant="primary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure? After creating the Login policy, all active sessions (except the current one){" "}
        <strong>will be invalidated</strong>.
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showLoginPolicyCreateConfirmationModal = (
  props: LoginPolicyCreateConfirmationModalProps
) => show(LoginPolicyCreateConfirmationModal, props);
